const ORDER_STATUS = {
  TO_REVIEW: "TO_REVIEW",
  VALIDATED: "VALIDATED",
  PENDING: "PENDING",
  WAITING_FOR_CUSTOMER: "WAITING_FOR_CUSTOMER",
  CANCELLED: "CANCELLED",
};

export { ORDER_STATUS };
